import React from "react";

const Brand = (
  <React.Fragment>
    Knowingo<sup>+</sup>
  </React.Fragment>
);

export default Brand;
